import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { quickReports } from '../../data/demandes';
import { AtnaConversationDialog } from './AtnaConversationDialog';
import { PromptBox } from './PromptBox';
const PANEL_LAYOUT_ID = 'atna-conversation-panel';
export function RequestComposer() {
  const [draft, setDraft] = useState('');
  const [openedWith, setOpenedWith] = useState<string | null>(null);
  const open = (value: string) => {
    const text = value.trim();
    if (!text) return;
    setOpenedWith(text);
    setDraft('');
  };
  const isOpen = openedWith !== null;
  return <section aria-labelledby="signaler-titre" data-id="element-989" data-mp="23owd5cs6t56v">
      <h2 id="signaler-titre" className="text-2xl font-extrabold tracking-tight text-ville-navy sm:text-3xl" data-id="element-990" data-mp="23q7d11iihssp">
        Signaler un problème
      </h2>
      <p className="mt-2 max-w-2xl text-[17px] text-slate-600" data-id="element-991" data-mp="s8ocxi08a5yd">
        Décrivez simplement ce que vous voyez. ATNA vous aide à transmettre la demande au bon service.
      </p>

      <div className="mt-6" data-id="element-992" data-mp="1k95tev78b7oz">
        {isOpen ?
      // Placeholder keeps the page from jumping while the pill morphs into the dialog.
      <div className="h-[66px]" aria-hidden="true" data-id="element-993" data-mp="1fbxagse9azmo" /> : <motion.div layoutId={PANEL_LAYOUT_ID} style={{
        borderRadius: 999
      }} transition={{
        duration: 0.28,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-994" data-mp="1tadrpd9qw8j2">
            <PromptBox value={draft} onChange={setDraft} onSubmit={() => open(draft)} onAddPhoto={() => open(draft)} variant="hero" placeholder="Que voulez-vous signaler ?" data-id="element-995" data-mp="1o9pta6j6spet" />
          </motion.div>}
      </div>

      <ul className="-mx-5 mt-4 flex snap-x gap-2.5 overflow-x-auto px-5 pb-1 sm:mx-0 sm:flex-wrap sm:overflow-visible sm:px-0" data-id="element-996" data-mp="2c2pw05jyljvu">
        {quickReports.map(quick => <li key={quick} className="shrink-0 snap-start" data-id="element-997" data-mp="2lzayok8iaiwi">
            <button type="button" onClick={() => open(quick)} className="rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-ville-navy transition-colors duration-150 ease-ville hover:border-ville-indigo hover:bg-ville-indigo-soft hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-998" data-mp="2h0845tq5jv2s">
              {quick}
            </button>
          </li>)}
      </ul>

      <AnimatePresence data-id="element-999" data-mp="1xd1of6vb5iy3">
        {openedWith !== null && <AtnaConversationDialog key="atna-dialog" initialText={openedWith} layoutId={PANEL_LAYOUT_ID} onClose={() => setOpenedWith(null)} data-id="element-1000" data-mp="1xci4jkm3kkhf" />}
      </AnimatePresence>
    </section>;
}